import { apiGet, apiPost, apiPut } from './client';

// ── Types ─────────────────────────────────────────────────────────────────────

export interface DigestConfig {
  id: string;
  enabled: boolean;
  timezone: string;
  morningTriggerTime: string | null;
  middayTriggerTime: string | null;
  categoryInclusion: string[];
  categoryExclusion: string[];
  maxConversations: number;
  sendIfEmpty: boolean;
  autoarchiveEnabled: boolean;
  autoarchiveAfterHours: number;
  autoarchiveAction: 'archive' | 'delete';
  recipientEmail: string;
  ccAddresses: string[];
  createdAt: string;
  updatedAt: string;
}

export interface DigestRunResult {
  runId: string;
  sent: boolean;
  conversationCount: number;
  clientCount: number;
  totalMatched: number;
  truncated: boolean;
}

export interface DigestPreviewResult {
  html: string;
}

// ── API calls ─────────────────────────────────────────────────────────────────

export async function getDigestConfig(): Promise<DigestConfig> {
  const res = await apiGet<{ config: DigestConfig }>('/api/digest/config');
  return res.config;
}

export async function updateDigestConfig(data: Partial<DigestConfig>): Promise<DigestConfig> {
  const res = await apiPut<{ config: DigestConfig }>('/api/digest/config', data);
  return res.config;
}

export async function triggerDigest(): Promise<DigestRunResult & { retryAfterSeconds?: number }> {
  return apiPost<DigestRunResult & { retryAfterSeconds?: number }>('/api/digest/trigger', {
    trigger_type: 'manual',
  });
}

export async function previewDigest(): Promise<DigestPreviewResult> {
  return apiPost<DigestPreviewResult>('/api/digest/preview', { trigger_type: 'manual' });
}

export async function getLatestDigest(): Promise<{ html: string | null; generatedAt: string | null }> {
  return apiGet('/api/digest/latest');
}
